export default __webpack_public_path__ + "static/media/lake-pic-hero.a2174cfd.jpeg";